import { Utils } from '@genial/utils';

export const messageError = '―';

const today = new Date();
export const formattedToday = Utils.Mask.DateFormat(today, 'dd/MM/yyyy');

export const screenName = 'batch-ticket-invest-link';
